"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

const tabs = [
  { id: "article", label: "Makale" },
  { id: "topic", label: "Konu" },
  { id: "reply", label: "Yanıt" },
] as const;

type TabId = (typeof tabs)[number]["id"];

const AdvisoryTabBar = ({
  slug,
  counts,
}: {
  slug: string;
  counts: Record<TabId, number>;
}) => {
  const pathname = usePathname();

  return (
    <ul className="flex flex-row gap-6 list-none border-b border-neutral-200">
      {tabs.map((tab) => {
        const isActive = pathname.endsWith(`/${tab.id}`);
        return (
          <li key={tab.id}>
            <Link
              className={cn(
                "inline-block pb-2 text-sm font-semibold text-neutral-500 border-b-2 border-transparent -mb-px transition-colors",
                isActive && "text-brand-blue-600 border-brand-blue-600",
              )}
              href={`/bilim-kurulu/${slug}/${tab.id}`}
            >
              {tab.label} ({counts[tab.id]})
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default AdvisoryTabBar;
